import { Box, CircularProgress } from '@mui/material'
import { FlexBoxProps, TokenAmount, useAsyncEffect } from '@xylabs/sdk-react'
import BigNumber from 'bn.js'
import { useContext, useState } from 'react'

import { MinterAuctionContext } from '../../Contexts'
import { shiftBase10 } from '../../shiftBase10'
import { Property } from '../Property'

const FlowedInProperty: React.FC<FlexBoxProps> = (props) => {
  const { auction } = useContext(MinterAuctionContext)

  const [flowedIn, setFlowedIn] = useState<BigNumber | null>()
  useAsyncEffect(
    // eslint-disable-next-line react-hooks/exhaustive-deps
    async (isMounted) => {
      const value = await auction?.getFlowed()
      if (!isMounted()) return
      setFlowedIn(value?.in)
    },
    [auction],
  )

  return (
    <Property title="XYO Flowed In" value={flowedIn === null ? null : shiftBase10(flowedIn, -18)?.toString(10)} {...props}>
      <Box>{flowedIn !== undefined ? <TokenAmount amount={flowedIn} /> : <CircularProgress size={24} />}</Box>
    </Property>
  )
}

export default FlowedInProperty
